// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"styles_sitemap__f72Zw"};